/**
 * Defaults for the admin's "Run official verification" form. The state used to be left blank, so the
 * admin had to know where the license was issued; it now comes from what the specialist submitted.
 */
export interface ExternalValidationForm {
  country: 'US' | 'CO';
  firstName: string;
  lastName: string;
  licenseNumber: string;
  state: string;
  colombiaDocumentType: string;
  colombiaDocumentNumber: string;
  notes: string;
}

export interface StateLicenseRow {
  state?: string;
  licenseNumber?: string;
  status?: string;
}

export interface SpecialistForDefaults {
  name?: string;
  licenseNumber?: string;
  verificationData?: { stateLicenses?: StateLicenseRow[] } | null;
  licensedJurisdictions?: Array<{ country?: string; region?: string }> | null;
}

const licenseState = (s: SpecialistForDefaults): string => {
  const fromSubmission = s.verificationData?.stateLicenses?.find(l => l?.state)?.state;
  const fromProfile = s.licensedJurisdictions?.find(j => j?.country === 'US' && j.region)?.region;
  return (fromSubmission || fromProfile || '').trim().toUpperCase();
};

export const externalValidationDefaults = (s: SpecialistForDefaults): ExternalValidationForm => {
  const [firstName = '', ...rest] = (s.name || '').trim().split(/\s+/).filter(Boolean);
  return {
    country: 'US',
    firstName,
    lastName: rest.join(' '),
    licenseNumber: s.licenseNumber || '',
    state: licenseState(s),
    colombiaDocumentType: '',
    colombiaDocumentNumber: '',
    notes: '',
  };
};
